<template>
  <div class="usmeBox">
    <div class="open-platform-header-text">
      <h1>{{ lanInfo.ContactUs }}</h1>
    </div>
    <div class="content">
      <div class="itembox clearfix">
        <div class="item">
          <div>
            <img src="../../assets/images/contact/us5.png" alt>
            <p>{{ lanInfo.SchemeCounseling }}</p>
            <p>18800023209</p>
          </div>
        </div>
        <div class="item">
          <div>
            <img src="../../assets/images/contact/us1.png" alt>
            <p>{{ lanInfo.ContactInformation }}</p>
            <p>010-86208510</p>
          </div>
        </div>

        <div class="item">
          <div>
            <img src="../../assets/images/contact/us2.png" alt>
            <p>{{ lanInfo.Email }}</p>
            <p>contact@legalXchain.com</p>
            <p>contact@truthso.com</p>
          </div>
        </div>

        <div class="item">
          <div>
            <img src="../../assets/images/contact/us3.png" alt>
            <p>Telegram</p>
            <a href="https://t.me/LegalXchain">
              <p class="p">{{ lanInfo.clickEnter }}>></p>
            </a>
          </div>
        </div>

        <div class="item" style="margin-right:0">
          <div>
            <img src="../../assets/images/contact/us4.png" alt>
            <p>Twitter</p>
            <a href="https://mobile.twitter.com/legalxchain/following">
              <p class="p">{{ lanInfo.clickEnter }}>></p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "openPlatformDetailContactUs",
  data() {
    return {
      showPic1: false,
      showPic2: false,
      showPic3: false,
      showPic4: false,
      showPic5: false,
      showPic6: false,
    }
  },
  computed: {
    lanInfo() {
      return this.$store.getters.getLanInfo.ContactUs;
    },
    lanType() {
      return this.$store.getters.getLanType;
    }
  },
  methods: {
    show() {
      setTimeout(() => {
        this.showPic1 = true;
      }, 800);
    },
  },
  watch: {
    showPic1(val) {
      if (val) {
        let index = 2;
        let interval = setInterval(() => {
          this["showPic" + index++] = true;
          if (index == 7) {
            clearInterval(interval);
            this.$emit('callback')
          }
        }, 800);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.usmeBox {
  height: 400px;
  background: #fafafa;

  .open-platform-header-text {
    text-align: center;
    padding: 40px 0;

    h1 {
      color: #000000;
      font-size: 26px;
    }
  }

  .itembox {
    .item {
      position: relative;
      width: 219px;
      float: left;
      text-align: center;
      border: 1px solid #ccc;
      height: 210px;
      box-sizing: border-box;
      margin-right: 26px;
      cursor: pointer;
      background: #fff;

      a {
        text-decoration: none;

        .p {
          &:hover {
            color: #0650ca;
          }
        }
      }

      & > div {
        position: absolute;
        width: 270px;
        height: 140px;
        left: 50%;
        top: 50%;
        margin-left: -135px;
        margin-top: -70px;
        font-size: 14px;

        p {
          &:nth-of-type(1) {
            color: #333;
          }

          &:nth-of-type(2) {
            color: #666;
          }

          &:nth-of-type(3) {
            color: #666;
            line-height: 12px;
          }
        }
      }

      img {
        margin-bottom: 10px;
        transition: all 0.7s ease-in-out 0s;

        &:hover {
          transform: rotate(360deg);
        }
      }

      p {
        line-height: 30px;
      }
    }
  }
}

.content {
  width: 1200px;
  overflow: hidden;
  margin: 0 auto;
}
</style>